import React from 'react';
import './FirstContent.scss';

export default class FirstContent extends React.Component {
    render() {
        const showComponent = this.props.firstContentView;
        if (showComponent) {
            return (
                <div className="FirstContent">
                    <h3>Добро пожаловать на сайт WSCproject!</h3>
                    <h4>Ваш персональный помощник в сфере строительства.</h4>
                    <p>Сайт посвящен строительству зданий и сооружений и, в целом, строительному искусству.</p>
                    <p>Сайт состоит из записок и тестов к ним на строительную тематику, структурированных в определенном порядке.</p>
                    <p>Здесь вы можете создавать и свои собственные записки на актуальные для вас темы, формировать из них задачи, публиковать их в общем доступе и в частном режиме.</p>
                    <p>Также вы можете сохранять  понравившиеся вам записки и делиться ими с другими пользователями.</p>
                    
                   
                </div>
            )
        } else return null;
        
    }
}